import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function urlSafeStringValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Allow null or empty values (use `Validators.required` if needed)
        if (!value) {
            return null;
        }

        const spaceRegex = /\s/;
        // Check if the value contains spaces
        if (spaceRegex.test(value)) {
            return { urlSafeString: true };
        }

        // Regular expression to match URL-safe strings (no spaces, only valid URL characters)
        const urlSafeRegex = /^[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]+$/;

        // Test the value against the regex
        const isValid = urlSafeRegex.test(value);

        // Return validation error if invalid
        return isValid ? null : { urlSafeString: true };
    };
}